import haircareSteps from '../lib/haircareQuiz';
import supplementSteps from '../lib/supplementQuiz';
import { normaliseKey } from './string';

/**
 * Submit the quiz answers to the server.
 * @param {object} data
 */
const submitQuiz = async (data) => {
  const quizType = localStorage.getItem('quiz-type');
  const steps = (quizType === 'supplement') ? supplementSteps : haircareSteps;

  console.log('Submit quiz function called with data:', data); // Log the raw input data

  const body = {};

  steps.forEach((step) => {
    step.steps.forEach((subStep) => {
      const name = subStep.field.name || subStep.heading;
      const normalisedName = normaliseKey(name);

      if (normalisedName in data) {
        body[name] = data[normalisedName];
      }
    });
  });

  console.log('Prepared body:', body); // Logging the prepared body

  body.persistedQuery = data.persistedQuery;
  body.previousHash = data.previousHash;

  const quizItem = {
    name: body['What should we call you?'],
    hash: null,
    created: Math.floor(Date.now() / 1000),
  };

  const orderEndpoint = (quizType === 'supplement') ? '/wp-json/quiz/get-supplement-nutritional-information' : '/wp-json/quiz/order';

  try {
    console.log('About to make initial fetch request with body:', body);
    const response = await fetch(orderEndpoint, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(body),
    });

    const json = await response.json();
    console.log('Response from initial fetch:', json);

    const {success, data = {}} = json;
    const {redirect = null} = data;

    if (success) {
      quizItem.hash = data.hash;

      const quizHistory = localStorage.getItem('quiz-history-' + quizType);
      if (quizHistory) {
        if (!quizHistory.includes(data.hash)) {
          const quizHistoryArray = JSON.parse(quizHistory);
          quizHistoryArray.push(quizItem);
          localStorage.setItem('quiz-history-' + quizType, JSON.stringify(quizHistoryArray));
        }
      } else {
        localStorage.setItem('quiz-history-' + quizType, JSON.stringify([quizItem]));
      }

      const product_name = body['What should we call you?'];
      const quiz_data = body;

      console.log('About to log submission with data:', {product_name, quiz_data});
      const logResponse = await fetch('/wp-json/quiz/log-submission', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({product_name, quiz_data}),
      });

      const logJson = await logResponse.json();
      console.log('Response from log submission:', logJson);

      console.log('Fetch request completed');
      localStorage.removeItem('order-form-state-' + quizType);
      window.location = redirect;
      return true;
    }

    console.warn(data);

    return false;
  } catch (error) {
    console.error('Error encountered:', error);
  }
};

export default submitQuiz;
